export default function login(creds: any): string {
  const data: any = {}
  // @ts-ignore
  if (creds.username === 'test' && creds.password === 'test') {
    data.token = 'mocked-token'
  } else {
    data.code = 403
    data.error = 'BAD_CREDENTIALS'
    data.message = 'The username or password has not been recognised.'
  }

  return JSON.stringify({
    data: {
      ...data,
    },
  })
}
